import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state(){
        return {
            waarnemer: null,
            waarnemers: null,
            boodschap: null,
        }
    },
    mutations: {
        setWaarnemers(state,waarnemers){
            state.waarnemers = waarnemers
        },
        setWaarnemer(state,waarnemer){
            state.waarnemer = waarnemer
        },
        setBoodschap(state, boodschap){
            state.boodschap = boodschap
        },
        clearWaarnemer(state) {
            state.waarnemer = null
        }
    },
    actions: {
        async fetchWaarnemers({commit}){
            axiosInstance.get('/zon/waarnemers')
                .then(result => commit('setWaarnemers',result.data))
        },
        fetchActieveWaarnemers({commit}){
            axiosInstance.get('/zon/waarnemers/actieve')
                .then(result => commit('setWaarnemers',result.data))
        },
        fetchNietActieveWaarnemers({commit}){
            axiosInstance.get('/zon/waarnemers/inActieve')
                .then(result => commit('setWaarnemers',result.data))
        },
        async fetchWaarnemer({commit},id){
            axiosInstance.get('/zon/waarnemers/' + id)
                .then(result => commit('setWaarnemer',result.data))
        },
        async fetchWaarnemerMetEmail({commit},email){
            await axiosInstance.get('/zon/waarnemers/byEmail/' + email)
                .then(result => {
                    commit('setWaarnemer',result.data)
                    return result.data
                })
                .catch(error => {
                    if (error.response) {
                        const apiError = error.response.data;
                        throw new Error(apiError.message);
                    } else {
                        console.error("Netwerk- of serverfout:", error);
                        throw error;
                    }
                });
        },
        async fetchWachtwoordIsJuist({},data){
            return axiosInstance.post('/zon/registratie/controleWW',data)
        },

        adjustDataWaarnemer({commit}, waarnemerDto){
            axiosInstance.put('/zon/waarnemers/changeData',waarnemerDto)
                .then(result=> commit('setWaarnemer', result.data))
        },
        setWachtwoord({},wachtwoordRequestDto){
            axiosInstance.put('/zon/waarnemers/admin/setwachtwoord/gebruiker',wachtwoordRequestDto)
                .then(() =>
                    console.log(" "))
                .catch(error => {
                    if (error.response) {
                        const apiError = error.response.data;
                        console.error("Foutcode:", apiError.status);
                        console.error("Fouttype:", apiError.error);
                        console.error("Foutmelding:", apiError.message);
                        console.error("Endpoint:", apiError.path);
                        throw new Error(apiError.message);
                    } else {
                        console.error("Netwerk- of serverfout:", error);
                        throw error;
                    }
                });
        },
       changeRol({},rolDto){
            axiosInstance.put('/zon/waarnemers/setRol/waarnemer', rolDto)
                .then(() =>
                     console.log("Rol succesvol gewijzigd"))
                .catch(error => {
                    if (error.response) {
                        const apiError = error.response.data;
                        console.error("Foutcode:", apiError.status);
                        console.error("Fouttype:", apiError.error);
                        console.error("Foutmelding:", apiError.message);
                        console.error("Endpoint:", apiError.path);
                        throw new Error(apiError.message);
                    } else {
                        console.error("Netwerk- of serverfout:", error);
                        throw error;
                    }
                });
        },
        async setTelescoop({ commit, dispatch }, data) {
            return axiosInstance
                .post('/zon/waarnemers/waarnemer/setTelescoop/' + data.id, data.telescoopDto)
                .then(result => {
                    commit('setWaarnemer', result.data)
                    const telescoopId = result.data.telescoopId
                    return dispatch('telescopenModule/fetchTelescoopById', telescoopId, { root: true });
                });
        },
        setWaarneemmethode({commit, dispatch},waarnemerDto){
            axiosInstance.post('/zon/waarnemers/waarnemer/aanpassen/setWaarneemmethode/',waarnemerDto)
                .then(result => {
                    commit('setWaarnemer', result.data)
                    const waarneemmethodeId = result.data.waarneemmethodeId
                    dispatch('methodenModule/fetchMethode',waarneemmethodeId,{root : true})
                })
        },
        registreerWaarnemer({ commit }, nieuweRegistratieDto) {
            return axiosInstance.post('/zon/registratie/nieuweWaarnemer', nieuweRegistratieDto)
                .then(() => {
                    console.log("Waarnemer succesvol geregistreerd.");
                })
                .catch(error => {
                    if (error.response) {
                        throw error.response.data
                    } else {
                        console.error("Netwerk- of serverfout:", error);
                        throw error;
                    }
                });
        },
        enableVersieBoodschap({commit},id){
            axiosInstance.put('/zon/waarnemers/developer/' + id)
                .then(result => commit('setWaarnemer',result.data))
        },

        setVersieBoodschappen(){
            return axiosInstance.put('/zon/waarnemers/developer/setVersieBoodschappen')
                .then(result => {
                    const antwoord = result.data === true;
                    return antwoord
                })
        }
    },
    getters:{},
}